import { useEffect, useState } from 'react';
import { TranscricaoDetalhe } from '../../../../interfaces/entities/Transcricao/TranscricaoDetalhe';
import { TranscricaoHistoricoStatus } from '../../../../interfaces/entities/Transcricao/TranscricaoHistoricoStatus';
import {
  recuperarTranscricaoDet,
  recuperarTranscricaoHistoricoStatus,
  recuperarTranscricaoHistoricoSumario,
} from '../../../../services/TranscricaoBeneficiarioService';

interface UseTranscricaoCarregamentoResult {
  loading: boolean;
  erro: string | null;
  detalhe: TranscricaoDetalhe | null;
  historicoStatus: TranscricaoHistoricoStatus | null;
  historicoSumario: TranscricaoHistoricoStatus[];
  erroHistoricoSumario: string | null;
}

export const useTranscricaoCarregamento = (
  idTranscricao: string | null,
): UseTranscricaoCarregamentoResult => {
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState<string | null>(null);
  const [detalhe, setDetalhe] = useState<TranscricaoDetalhe | null>(null);
  const [historicoStatus, setHistoricoStatus] = useState<TranscricaoHistoricoStatus | null>(null);
  const [historicoSumario, setHistoricoSumario] = useState<TranscricaoHistoricoStatus[]>([]);
  const [erroHistoricoSumario, setErroHistoricoSumario] = useState<string | null>(null);

  useEffect(() => {
    if (!idTranscricao) {
      setErro('Transcrição não encontrada.');
      setDetalhe(null);
      setHistoricoStatus(null);
      setHistoricoSumario([]);
      setErroHistoricoSumario(null);
      setLoading(false);
      return;
    }

    let cancelled = false;

    const carregar = async () => {
      setLoading(true);
      setErro(null);
      setErroHistoricoSumario(null);

      const [detalheResultado, statusResultado, sumarioResultado] = await Promise.all([
        recuperarTranscricaoDet(idTranscricao),
        recuperarTranscricaoHistoricoStatus(idTranscricao),
        recuperarTranscricaoHistoricoSumario(idTranscricao),
      ]);

      if (cancelled) return;

      if (!detalheResultado.ok) {
        setErro(detalheResultado.message);
        setDetalhe(null);
        setHistoricoStatus(null);
        setHistoricoSumario([]);
        setErroHistoricoSumario(null);
        setLoading(false);
        return;
      }

      const detalheCarregado = detalheResultado.data;
      setDetalhe(detalheCarregado);
      setHistoricoStatus(
        statusResultado.ok
          ? statusResultado.data
          : {
              codStatusTranscricao: detalheCarregado.codStatusTranscricao ?? undefined,
            },
      );

      if (sumarioResultado.ok) {
        setHistoricoSumario(sumarioResultado.data);
        setErroHistoricoSumario(null);
      } else {
        setHistoricoSumario([]);
        setErroHistoricoSumario(sumarioResultado.message);
      }

      setLoading(false);
    };

    void carregar();

    return () => {
      cancelled = true;
    };
  }, [idTranscricao]);

  return { loading, erro, detalhe, historicoStatus, historicoSumario, erroHistoricoSumario };
};
